import { CheckIcon, ClipboardIcon } from '@heroicons/react/outline';

import useLocale from 'next-translate/useTranslation';
import React, { useState } from 'react';

import Button from '../buttons/Button';

import { SimpleTooltip } from '@/components/ui/tooltip';

type Props = {
  value: string;
  showText?: boolean;
  iconSize?: string;
  text?: string;
  variant?:
    | 'light'
    | 'primary'
    | 'outline'
    | 'ghost'
    | 'dark'
    | 'simple'
    | 'plain'
    | undefined;
  disabled?: boolean;
};

export const CopyBtn: React.FC<Props> = ({
  value,
  showText = true,
  iconSize = 'w-4 h-4',
  variant = 'light',
  text = 'Copy',
  disabled = false,
}) => {
  const { t } = useLocale('common');

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <SimpleTooltip title={t('Copy')}>
      <Button disabled={disabled} variant={variant} onClick={handleCopy}>
        {copied ? (
          <>
            <CheckIcon className={iconSize + ' mr-1 '} />
            {showText && <span className='break-keep'>{t('Copied')}</span>}
          </>
        ) : (
          <>
            <ClipboardIcon className={iconSize + ' mr-1 '} />
            {showText && <span className='break-keep'>{t(text)}</span>}
          </>
        )}
      </Button>
    </SimpleTooltip>
  );
};
